import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LibButtonComponent } from './button.component';
import { MatButtonModule } from '@angular/material/button';



@NgModule({
  declarations: [
    LibButtonComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule
  ],
  exports: [
    LibButtonComponent
  ]
})
export class LibButtonModule { }
